import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { WebService } from '../api/web.service'
import { AppState } from 'src/app/store/state/app.state'
import { KnowledgeAPIModel, PaginatedAPI } from 'src/app/models/api.model'
import {
  PUBLISH_KNOWLEDGE_ARTICLE_ACTION,
  save_knowledge_action,
  search_knowledge_action,
  UPDATE_KNOWLEDGE_ARTICLE_ACTION,
  view_knowledge_action
} from 'src/app/store/action/knowledge.action'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'
import { BehaviorSubject, map, Observable } from 'rxjs'
import { getKnowledgeDetails } from 'src/app/store/selector/knowledge.selector'

@Injectable({
  providedIn: 'root'
})
export class KnowledgeService {
  knowledgeRefresh = new BehaviorSubject(false)

  constructor(private readonly webservice: WebService, private readonly appState: Store<AppState>) {}

  dispatchSaveKnowledgeAction(knowledge: KnowledgeAPIModel, files: File[], routeTo: string) {
    this.appState.dispatch(save_knowledge_action({ knowledge, files, routeTo }))
  }

  callSaveApi = (knowledge: KnowledgeAPIModel, files: File[]) => {
    const endPoint = ServiceUrlConstants.API_SAVE_KNOWLEDGE

    const formData: FormData = new FormData()
    const activityBlob = new Blob([JSON.stringify(knowledge)], { type: 'application/json' })
    formData.append('knowledgeArticle', activityBlob)

    if (files) {
      for (const element of files) {
        formData.append('documentList', element)
      }
    }

    return this.webservice.post(endPoint, formData, null, [], false).pipe(map((data: KnowledgeAPIModel) => data))
  }

  dispatchUpdateKnowledgeArticleAction(
    knowledgeArticle: Partial<KnowledgeAPIModel>,
    id: string,
    files: File[],
    routeTo: string
  ) {
    return this.appState.dispatch(UPDATE_KNOWLEDGE_ARTICLE_ACTION({ knowledgeArticle, id, files, routeTo }))
  }

  callUpdateApi = (activity: Partial<KnowledgeAPIModel>, id: string, files?: File[]) => {
    const endPoint = ServiceUrlConstants.API_UPDATE_KNOWLEDGE_ARTICLE + id
    const formData: FormData = new FormData()
    const activityBlob = new Blob([JSON.stringify(activity)], { type: 'application/json' })
    formData.append('knowledgeArticle', activityBlob)

    if (files) {
      for (const element of files) {
        formData.append('documentList', element)
      }
    }

    return this.webservice.put(endPoint, formData, null, [], false).pipe(map((data: KnowledgeAPIModel) => data))
  }

  dispatchViewKnowledgeAction(id: string, includeDocumentLinks: boolean) {
    this.appState.dispatch(view_knowledge_action({ id, includeDocumentLinks }))
  }

  callViewApi = (id: string, includeDocumentLinks: boolean) => {
    const endPoint = `${ServiceUrlConstants.API_VIEW_KNOWLEDGE}${id}?includeDocumentLinks=${includeDocumentLinks}`
    return this.webservice.get(endPoint).pipe(map((data: KnowledgeAPIModel) => data))
  }

  dispatchSearchKnowledgeAction(option) {
    this.appState.dispatch(search_knowledge_action(option))
  }

  invokeKnowledgeSummaryAPI = (queryParams: { key: string; value: string }[], searchRequestBody) => {
    return this.webservice
      .post(ServiceUrlConstants.API_VIEW_KNOWLEDGE_SEARCH_LIST, searchRequestBody, null, queryParams)
      .pipe(map((data: PaginatedAPI<KnowledgeAPIModel>) => data))
  }

  getKnowledgeArticleFromStore = (): Observable<KnowledgeAPIModel> => {
    return this.appState.select(getKnowledgeDetails())
  }

  dispatchPublishKnowledgeAction(id: string) {
    this.appState.dispatch(PUBLISH_KNOWLEDGE_ARTICLE_ACTION({ id }))
  }

  invokePublishKnowledgeSummaryAPI = (id: string) => {
    return this.webservice.post(ServiceUrlConstants.API_PUBLISH_KNOWLEDGE_ARTICLE.replace('{0}', id), {}, null)
  }
}
